export type Standard =
  | 'AASB_116' | 'AASB_16' | 'AASB_15' | 'AASB_137' | 'AASB_136' | 'AASB_101'
  | 'AASB_102' | 'AASB_119' | 'AASB_138'
  | 'AASB_124' | 'AASB_133' | 'AASB_8' | 'AASB_9'
  | 'AASB_112' | 'AASB_107' | 'AASB_121' | 'AASB_123' | 'AASB_1058';

export type Severity = 'info' | 'warning' | 'error';

export interface Finding {
  id: string;
  rowId?: string;
  ruleId: string;
  standard: Standard;
  severity: Severity;
  title: string;
  message: string;
  evidence: Record<string, unknown>;
  suggestedAdjustment?: {
    field: string;
    from: number | null;
    to: number | null;
    rationale: string;
  };
  rulepackVersion: string;
}

export interface ValidationSummary {
  standard: Standard;
  rulepackVersion: string;
  rowsTested: number;
  compliant: number;
  byseverity: { info: number; warning: number; error: number };
  totalCarryingValue?: number;
  aggregateDelta?: number;
  runAt: string;
}

export interface ValidationResult {
  summary: ValidationSummary;
  findings: Finding[];
  schemaErrors?: string[];
  disclaimer: string;
}

export const DISCLAIMER =
  'This tool supports internal financial validation and does not replace professional ' +
  'judgement. Findings are produced by deterministic rule checks and AI-assisted ' +
  'commentary against Australian Accounting Standards (AASB). Reported items should ' +
  'be reviewed by a qualified accountant or auditor before reliance.';
